import { OkvedInfoDto } from '@sr/dto';
import { okvedApi } from '../api-slice';
import { IRemoteCollection } from 'utils/remote-collection.hook';


export const useOkvedDropdown = (): IRemoteCollection<OkvedInfoDto> => {
  const { data, isLoading, refetch } = okvedApi.useGetOkvedDropdownQuery();
  return {
    items: data ?? [],
    isLoading: isLoading,
    error: '',
    reload: () => refetch(),
  };
};